import cn from "classnames";
import { IRenderFormField, ISelectOption } from "src/@types/form";
import { SingleButtonSelectorField } from "src/components/FormField/SingleButtonSelectorField";
import { formFieldTrns } from "src/components/FormField/trns";
import { SingleSelectField } from "src/components/FormField/SingleSelectField";
import { TextField } from "src/components/FormField/TextField";
import { MultiSelectField } from "src/components/FormField/MultiSelectField";
import { MultiDocField } from "src/components/FormField/MultiDocField";
import { EditorField } from "src/components/FormField/EditorField";
import { DOC_FILE_ACCEPT } from "src/components/FormField/constants";
import { INTERNATIONAL_OPTION, ROLE_OPTIONS } from "./options";
import { RegistrationFields } from "../types";

const DEFAULT_SELECTOR_CLASSNAME = "px-5 py-2 md:px-5 md:py-3.5 font-semibold";
const DEFAULT_ERROR_CLASSNAME = "absolute -bottom-5 lg:-bottom-6";

export const ROLE_FIELD: IRenderFormField[] = [
  {
    component: SingleButtonSelectorField,
    name: RegistrationFields.role,
    selectorClassName: cn(DEFAULT_SELECTOR_CLASSNAME, "!justify-start"),
    className: "flex flex-col !gap-3 md:flex-row",
    options: ROLE_OPTIONS,
  },
];

export const getCountryField = (countries: ISelectOption[] = []) => [
  {
    component: SingleSelectField,
    name: RegistrationFields.country,
    label: { i18nKey: formFieldTrns.country },
    options: countries,
    errorClassName: DEFAULT_ERROR_CLASSNAME,
  },
];

export const COMPANY_NAME_ADDRESS_SITE_FIELDS: IRenderFormField[] = [
  {
    component: TextField,
    name: RegistrationFields.companyName,
    label: { i18nKey: formFieldTrns.companyName },
    errorClassName: DEFAULT_ERROR_CLASSNAME,
  },
  {
    component: TextField,
    name: RegistrationFields.companyAddress,
    label: { i18nKey: formFieldTrns.legalAddress },
    errorClassName: DEFAULT_ERROR_CLASSNAME,
  },
  {
    component: TextField,
    name: RegistrationFields.website,
    placeholder: "https://www.businessclone.com",
    label: { i18nKey: formFieldTrns.websiteLink },
    errorClassName: DEFAULT_ERROR_CLASSNAME,
  },
];

export const NAMES_FIELDS: IRenderFormField[] = [
  {
    component: TextField,
    name: RegistrationFields.firstName,
    label: { i18nKey: formFieldTrns.firstName },
    errorClassName: DEFAULT_ERROR_CLASSNAME,
  },
  {
    component: TextField,
    name: RegistrationFields.lastName,
    label: { i18nKey: formFieldTrns.lastName },
    errorClassName: DEFAULT_ERROR_CLASSNAME,
  },
];

export const DESCRIPTION_FIELD: IRenderFormField[] = [
  {
    component: EditorField,
    name: RegistrationFields.description,
    label: { i18nKey: formFieldTrns.description },
    errorClassName: DEFAULT_ERROR_CLASSNAME,
  },
];

export const getIndustryField = (
  industries: ISelectOption[] = []
): IRenderFormField[] => [
  {
    component: SingleSelectField,
    name: RegistrationFields.industry,
    label: { i18nKey: formFieldTrns.industry },
    errorClassName: DEFAULT_ERROR_CLASSNAME,
    options: industries,
  },
];

export const INTERNATIONAL_FIELD: IRenderFormField[] = [
  {
    component: SingleButtonSelectorField,
    name: RegistrationFields.international,
    selectorClassName: DEFAULT_SELECTOR_CLASSNAME,
    className: "!gap-3",
    errorClassName: DEFAULT_ERROR_CLASSNAME,
    options: INTERNATIONAL_OPTION,
  },
];

export const getReprecentionCountriesField = (
  countriesOptions: ISelectOption[] = []
): IRenderFormField[] => [
  {
    component: MultiSelectField,
    name: RegistrationFields.reprecentionCountries,
    label: { i18nKey: formFieldTrns.countries },
    errorClassName: DEFAULT_ERROR_CLASSNAME,
    options: countriesOptions,
  },
];

export const FOUNDING_DOCS_FIELD: IRenderFormField[] = [
  {
    component: MultiDocField,
    className: "!text-base sm:!text-xl",
    placeholder: "PDF, Word, Excel",
    accept: DOC_FILE_ACCEPT,
    name: RegistrationFields.foundingDocs,
    errorClassName: DEFAULT_ERROR_CLASSNAME,
  },
];

export const PHONE_EMAIL_PASSWORD_FIELDS: IRenderFormField[] = [
  {
    component: TextField,
    type: "tel",
    name: RegistrationFields.phoneNumber,
    label: { i18nKey: formFieldTrns.phoneNumber },
    errorClassName: DEFAULT_ERROR_CLASSNAME,
  },
  {
    component: TextField,
    name: RegistrationFields.email,
    label: { i18nKey: formFieldTrns.email },
    errorClassName: DEFAULT_ERROR_CLASSNAME,
  },
  {
    component: TextField,
    name: RegistrationFields.password,
    label: { i18nKey: formFieldTrns.password },
    type: "password",
    errorClassName: DEFAULT_ERROR_CLASSNAME,
  },
];
